const styles = {
	formContainer: {
		'& .form-title': { mb: 3 },
	},
};

export default styles;
